<template>
    <div class="saved-vehicles__container">
        <div class="saved-vehicles__title-row">
            <h1 class="saved-vehicles__heading h1">Saved Vehicles</h1>
            <button v-if="newVehicles.length > 0" @click="changeView('new')" class="btn btn--full-width-xs btn--secondary" :class="{ 'active': currentView == 'new' }">New Vehicles</button>
            <button v-if="usedVehicles.length > 0" @click="changeView('used')" class="btn btn--full-width-xs btn--secondary" :class="{ 'active': currentView == 'used' }">Used Vehicles</button>
            <button v-if="motabilityVehicles.length > 0" @click="changeView('motability')" class="btn btn--full-width-xs btn--secondary" :class="{ 'active': currentView == 'motability' }">Motability Vehicles</button>
        </div>
        <br>

        <template v-if="currentView == 'used'">
            <template v-if="usedResults.length > 0">
                <div class="search-results__results-container">
                    <template v-for="vehicle in usedResults">
                        <stock-search-vehicle-result v-if="vehicle.is_new == 1" :vehicle="vehicle" :key="vehicle.id"></stock-search-vehicle-result>
                        <used-vehicle-result v-else :vehicle="vehicle" :key="vehicle.id"></used-vehicle-result>
                    </template>
                </div>
                <saved-vehicles-paging :pages="usedPaging" v-on:change-page="getUsedResults"></saved-vehicles-paging>
            </template>
            <template v-else-if="!usedResultsLoading">
                <p class="text-center">
                    <br />
                    <br />
                    0 stock vehicles have been saved
                </p>
            </template>
            <div class="search-results__results-container" v-if="usedResultsLoading">
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
            </div>

            <p v-if="usedVehicles.length > 0" class="terms" id="bottom-terms">
                *<template v-if="personalQuote">This is your personal quote, we will retain your deposit as you move around the website. </template>Quotes are valid for a maximum of 14 days from {{ date }} and may be withdrawn without
                notice. Finance subject to status and age limitations. We may introduce you to a carefully selected group of finance providers. Stellantis &You UK Limited, trading as Stellantis &You Sales & Services, is acting as a credit broker
                and not a lender and will introduce you to a limited number of lenders. <a href="/terms-and-conditions">Ts and Cs apply</a>.
            </p>
        </template>
        <template v-else-if="currentView == 'new'">
            <template v-if="newResults.length > 0">
                <div style="overflow-x: auto">
                    <table class="table saved-vehicles__new-table table-responsive">
                        <tr>
                            <th class="image">Image</th>
                            <th class="make">Make, Model</th>
                            <th><img class="saved-vehicles__spec-icon spec-manual-icon" alt="Transmission" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th>
                            <th><img class="saved-vehicles__spec-icon spec-fuel-icon" alt="Fuel" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th>
                            <th><img class="saved-vehicles__spec-icon spec-mpg-icon" alt="MPG" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th>
                            <th><img class="saved-vehicles__spec-icon spec-co2-icon" alt="CO2" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th>
                            <!-- <th><img class="saved-vehicles__spec-icon spec-road-tax-icon" alt="Road Tax" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th> -->
                            <th><img class="saved-vehicles__spec-icon spec-bhp-icon" alt="BHP" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th>
                            <th class="price">Price</th>
                            <th>&nbsp;</th>
                        </tr>
                        <new-vehicle-result v-for="vehicle in newResults" :key="vehicle.cap_id" :is-motab="false" :vehicle="vehicle" v-on:removed-item="getNewResults(1)"></new-vehicle-result>
                    </table>
                </div>
                <saved-vehicles-paging :pages="newPaging" v-on:change-page="getNewResults"></saved-vehicles-paging>
            </template>
            <template v-else-if="!newResultsLoading">
                <p class="text-center">
                    <br />
                    <br />
                    0 new vehicles have been saved
                </p>
            </template>
        </template>
        <template v-else-if="currentView == 'motability'">
            <template v-if="motabilityResults.length > 0">
                <div style="overflow-x: auto">
                    <table class="table saved-vehicles__new-table table-responsive">
                        <tr>
                            <th class="image">Image</th>
                            <th class="make">Make, Model</th>
                            <th><img class="saved-vehicles__spec-icon spec-manual-icon" alt="Transmission" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th>
                            <th><img class="saved-vehicles__spec-icon spec-fuel-icon" alt="Fuel" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th>
                            <th><img class="saved-vehicles__spec-icon spec-mpg-icon" alt="MPG" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th>
                            <th><img class="saved-vehicles__spec-icon spec-co2-icon" alt="CO2" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th>
                            <!-- <th><img class="saved-vehicles__spec-icon spec-road-tax-icon" alt="Road Tax" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th> -->
                            <th><img class="saved-vehicles__spec-icon spec-bhp-icon" alt="BHP" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaAQMAAAACZtNBAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABJJREFUeNpjYBgFo2AUjILBAgAEkgABCoK5SwAAAABJRU5ErkJggg=="></th>
                            <th class="price">Price</th>
                            <th>&nbsp;</th>
                        </tr>
                        <new-vehicle-result v-for="vehicle in motabilityResults" :key="vehicle.cap_id" :is-motab="true" :vehicle="vehicle" v-on:removed-item="getMotabilityResults(1)"></new-vehicle-result>
                    </table>
                </div>
                <saved-vehicles-paging :pages="motabilityPaging" v-on:change-page="getMotabilityResults"></saved-vehicles-paging>
            </template>
            <template v-else-if="!motabilityResultsLoading">
                <p class="text-center">
                    <br />
                    <br />
                    0 new vehicles have been saved
                </p>
            </template>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import SavedVehiclesAPI from '../api/SavedVehiclesAPI';
import UsedVehicleFinance from '../api/finance/UsedVehicleFinance';
import UsedVehicleResultLoader from '../components/ContentLoaders/UsedVehicleResult.vue';
import NewVehicleResult from '../components/NewVehicleResult.vue';
import UsedVehicleResult from '../components/UsedVehicleResult.vue';
import StockSearchVehicleResult from '../components/StockSearch/StockSearchVehicleResult.vue';
import SavedVehiclesPaging from '../components/SavedVehiclesPaging.vue';

export default {
    components: {
        UsedVehicleResult,
        StockSearchVehicleResult,
        UsedVehicleResultLoader,
        NewVehicleResult,
        SavedVehiclesPaging
    },
    props: {
        type: {
            default: 'used',
            validator: value => ['used', 'new', 'motability'].indexOf(value) !== -1,
        },
    },
    data() {
        return {
            currentView: 'used',

            usedResults: [],
            usedPaging: {
                last_page: 1,
                current_page: 1
            },
            usedResultsLoading: true,

            newResults: [],
            newPaging: {
                last_page: 1,
                current_page: 1
            },
            newResultsLoading: true,

            motabilityResults: [],
            motabilityPaging: {
                last_page: 1,
                current_page: 1
            },
            motabilityResultsLoading: true,

            usedInitialized: false,
            newInitialized: false,
            motabilityInitialized: false,
        };
    },
    computed: {
        ...mapState('FinanceParameters', {
            'personalQuote': 'modified'
        }),
        date() {
            const date = new Date();
            return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
        },
        newVehicles() {
            return (this.$store.state.Layout.compare.new) ? this.$store.state.Layout.compare.new : [];
        },
        usedVehicles() {
            return (this.$store.state.Layout.compare.used) ? this.$store.state.Layout.compare.used : [];
        },
        motabilityVehicles() {
            return (this.$store.state.Layout.compare.motability) ? this.$store.state.Layout.compare.motability : [];
        },
    },
    watch: {
        currentView: function(newVal, oldVal) {
            if (newVal == 'new' && this.newInitialized == false) {
                this.getNewResults(1);
                return;
            }
            if (newVal == 'used' && this.usedInitialized == false) {
                this.getUsedResults(1);
                return;
            }
            if (newVal == 'motability' && this.motabilityInitialized == false) {
                this.getMotabilityResults(1);
                return;
            }
        },
        '$route' (to, from) {
            this.currentView = to.params.type;
        }
    },
    methods: {
        changeView(newView) {
            if (this.currentView !== 'new' && newView == 'new') {
                this.$router.push({ name: 'saved-vehicles', params: { type: 'new' } });
                return;
            }
            if (this.currentView !== 'used' && newView == 'used') {
                this.$router.push({ name: 'saved-vehicles', params: { type: 'used' } });
                return;
            }
            if (this.currentView !== 'motability' && newView == 'motability') {
                this.$router.push({ name: 'saved-vehicles', params: { type: 'motability' } });
                return;
            }
        },
        getUsedResults(page) {
            this.usedResults = [];
            this.usedResultsLoading = true;
            this.usedInitialized = true;
            SavedVehiclesAPI.getUsedSavedVehicles({ page })
                .then((results) => {
                    this.usedResults = results.data.data;
                    this.usedPaging = {
                        last_page: results.data.last_page,
                        current_page: results.data.current_page
                    };
                    this.usedResultsLoading = false;
                    const usedVehicleFinance = new UsedVehicleFinance();
                    usedVehicleFinance.setTerm(this.$store.state.UsedSearchOptions.defaultTerm);
                    usedVehicleFinance.setDeposit(this.$store.state.UsedSearchOptions.defaultDeposit);
                    usedVehicleFinance.setMileage(this.$store.state.UsedSearchOptions.defaultAnnualMileage);
                    usedVehicleFinance.setVehicles(results.data.data);
                    usedVehicleFinance.getFinance()
                        .then(updatedVehicles => {
                            for (let i = 0, len = this.usedResults.length; i < len; i += 1) {
                                if (typeof this.usedResults[i] == 'undefined' || !this.usedResults[i]) {
                                    continue;
                                }
                                for (let j = 0, len = updatedVehicles.length; j < len; j += 1) {
                                    if (this.usedResults[i].id == updatedVehicles[j].id) {
                                        Vue.set(this.usedResults[i], 'finance', ((updatedVehicles[j].finance) ? updatedVehicles[j].finance : false));
                                    }
                                }
                            }
                        })
                        .catch(updatedVehicles => {
                            for (let i = 0, len = this.usedResults.length; i < len; i += 1) {
                                if (typeof this.usedResults[i] == 'undefined' || !this.usedResults[i]) {
                                    continue;
                                }
                                for (let j = 0, len = updatedVehicles.length; j < len; j += 1) {
                                    if (this.usedResults[i].id == updatedVehicles[j].id) {
                                        Vue.set(this.usedResults[i], 'finance', ((updatedVehicles[j].finance) ? updatedVehicles[j].finance : false));
                                    }
                                }
                            }
                        });
                })
                .catch((error) => {
                    this.usedResults = [];
                    this.usedResultsLoading = false;
                });
        },
        getNewResults(page) {
            this.newResultsLoading = true;
            this.newInitialized = true;
            SavedVehiclesAPI.getNewSavedVehicles({ page })
                .then((results) => {
                    this.newResults = results.data.data;
                    this.newPaging = {
                        last_page: results.data.last_page,
                        current_page: results.data.current_page
                    };
                    this.newResultsLoading = false;
                })
                .catch((error) => {
                    this.newResults = [];
                    this.newResultsLoading = false;
                });
        },
        getMotabilityResults(page) {
            this.motabilityResultsLoading = true;
            this.motabilityInitialized = true;
            SavedVehiclesAPI.getMotabilitySavedVehicles({ page })
                .then((results) => {
                    this.motabilityResults = results.data.data;
                    this.motabilityPaging = {
                        last_page: results.data.last_page,
                        current_page: results.data.current_page
                    };
                    this.motabilityResultsLoading = false;
                })
                .catch((error) => {
                    this.motabilityResults = [];
                    this.motabilityResultsLoading = false;
                });
        },
    },
    created() {
        this.currentView = this.type;
        if (this.currentView == 'used') {
            this.getUsedResults(1);
        }
        if (this.currentView == 'new') {
            this.getNewResults(1);
        }
        if (this.currentView == 'motability') {
            this.getMotabilityResults(1);
        }
    }
}
</script>

<style lang="scss">
    @import "resources/assets/sass/used/search-results.scss";
    @import "resources/assets/sass/used/saved-vehicles.scss";
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/views/saved-vehicles.vue